import { MaxLength, NonEmptyString } from '../validators/string';
import { PositiveNumber } from '../validators/number';
import { PasswordValidationCallbacks } from '@/services/misc/functions/ValidationFunctions';

interface FormFields {
  server: string;
  websiteId: number;
  homeDir: string;
  systemUserId: number;
  username: string;
  password: string;
}

type FieldRules = {
  [name in keyof FormFields]: Array<
    (value: FormFields[name]) => string | boolean
  >;
};

export const DefaultFtpUserFieldRules: FieldRules = {
  server: [
    NonEmptyString('Server is required!'),
  ],
  websiteId: [
    PositiveNumber('Website is required!'),
  ],
  homeDir: [
    NonEmptyString('Home directory is required!'),
  ],
  systemUserId: [
    PositiveNumber('System user is required!'),
  ],
  username: [
    NonEmptyString('Username is required!'),
    MaxLength(15, 'Username must be max 15 characters'),
  ],
  password: [
    NonEmptyString('Password is required!'),
    ...PasswordValidationCallbacks,
  ],
};

export default class CreateFtpUserForm implements FormFields {
  public server: string = '';
  public websiteId: number = -1;
  public homeDir: string = '';
  public systemUserId: number = -1;
  public username: string = '';
  public password: string = '';

  public rules: FieldRules = DefaultFtpUserFieldRules;
}
